export default "__VITE_ASSET__B7D7Cl6j__"